import { Component, OnInit } from '@angular/core';
import { ThemeSettingService } from '../services/theme-setting.service';
import { HttpClient } from '@angular/common/http';
import { ThemeSetting } from '../objects/ThemeObject';
import { SafeHtml } from '@angular/platform-browser';
import { EnvService } from '../env.service';

@Component({
  selector: 'app-vendor-applications',
  templateUrl: './vendor-applications.component.html',
  styleUrls: ['./vendor-applications.component.css']
})
export class VendorApplicationsComponent implements OnInit {

  serviceUrl: string;
  vendorApplications: SafeHtml;
  userGuide: string;
  isBusy: boolean = false;
  loaderConfig: any;

  constructor(private themeSettingService: ThemeSettingService, private http:HttpClient, private env: EnvService) {
    this.serviceUrl = this.env.servicePath;
    this.userGuide = this.env.allowSupplierApplication;
   }

  ngOnInit() {
    let themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
    this.isBusy = true;
    this.http.get("assets/external-html/vendor-applications.html", { responseType: "text" }).subscribe(result => {
      this.vendorApplications = result;
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
    })
  }
}
